<template>
    <v-dialog  persistent  v-model="dialog" width="500px">      
      <v-card >
        <v-card-title :class="`modal-title-bar`" >Maak een Event aan</v-card-title>       
        <v-card-text>
            <v-layout column>           
                <v-flex xs12 px-2>
                    <v-select 
                        item-value="id"
                        item-text="name"                                 
                        :items="userEvents"
                        label="Kies een event"
                        v-model="unitTypeEventId"
                        required
                    ></v-select>                     
                </v-flex>     
                <v-flex xs12 px-2>                            
                    <v-textarea
                    v-model="shortText"                     
                    label="Korte tekst ter uitleg"
                    :rules="[formRules.shortText]"
                    required
                    outline>
                    </v-textarea>
                </v-flex>     
            </v-layout>
        </v-card-text>
        <v-card-actions >          
          <v-btn  @click="$emit('closeClicked')">Sluiten</v-btn>
          <v-spacer></v-spacer>
          <v-btn  @click="saveUserEvent()" color="success">Opslaan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import * as types from "../../store/types"
  import ColorMixin from "../../plugins/mixins/ColorMixin"

  export default{    
      props:['asset'],
      mixins: [ColorMixin],
      data(){
          return {
              formRules:{
                  unitTypeEventId:(value) => {return (value) ? true : "Veld verplicht"},
                  shortText:(value) => {return (value) ? true : "Veld verplicht"},
              },
              unitTypeEventId:null,
              shortText:"",
              dialog: true,
          }
      },
      computed:{
        ...mapGetters({
          userEvents: types.UNIT_TYPE_EVENTS,
          currentUser: types.CURRENT_USER 
        })
      },
      methods:{        
          saveUserEvent(){
          
              let save = {}
              save.assetId         = this.asset.id
              save.shortText       = this.shortText
              save.unitTypeEventId = this.unitTypeEventId
              save.addedById       = this.currentUser.id

              this.$store.dispatch(types.SAVE_ASSET_USER_EVENT, {data:save}).then(() => {
                  this.$emit("saved",save)
              })      
          }
      },
      mounted(){
        this.$store.dispatch(types.UNIT_TYPE_EVENTS, {params: {iotEvent:"false", unitTypeId:this.asset.unitTypeId, include:"dataField"}}).then(() => { })      
      }
  }
</script>
